import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SegmentedControl from "../../../components/ui/SegmentedControl";
import { Button } from "../../../components/ui";

/**
 * Единая шапка раздела «План лечения»: табы
 * «План лечения / Рекомендации / Лист назначений» слева и одна и та же
 * кнопка «Вернуться в список» справа — на всех трёх экранах.
 *
 * `extra` — дополнительные кнопки перед «Вернуться» (например, «Печать»
 * в листе назначений).
 *
 * active: "plan" | "recommendations" | "appointments"
 */
const PlanTabs = ({ active, extra = null }) => {
    const { t } = useTranslation("patient");
    const navigate = useNavigate();
    const { patientId, planId } = useParams();

    const currentPlanId = Number(planId) || 0;

    const base = `/patient/${patientId}/plan/${currentPlanId}`;
    const items = [
        { value: "plan", label: t("plan.tabs.plan") },
        { value: "recommendations", label: t("plan.tabs.recommendations") },
        { value: "appointments", label: t("plan.tabs.appointments") },
    ];

    const handleChange = (value) => {
        if (!value || value === active || !currentPlanId) return;
        navigate(value === "plan" ? base : `${base}/${value}`);
    };

    return (
        <div className="plan-tabs">
            {currentPlanId ? (
                <SegmentedControl
                    ariaLabel={t("plan.tabs.ariaLabel")}
                    items={items}
                    onChange={handleChange}
                    size="md"
                    value={active}
                />
            ) : null}
            <div className="plan-tabs__right">
                {extra}
                <Button
                    icon="back"
                    onClick={() => navigate(`/patient/${patientId}/plan`)}
                    title={t("plan.buttons.backToList")}
                    variant="primary">
                    {t("plan.buttons.backToList")}
                </Button>
            </div>
        </div>
    );
};

export default PlanTabs;
